export default __webpack_public_path__ + "static/media/Slide31.0d652934.jpg";